import $ from 'jquery';

export default function ArticleDisplay() {
    // Wait for the DOM to be ready
    $(function() {
        initArticleDisplay();
    });

    let initArticleDisplay = function () {
        $(".article-wrapper .category-wrapper .category").on("click", function () {
            onCategorySelection(this);
        });

        $(document).on("click", ".article-wrapper .pager .prev", function () {
            onPagerPrevClick(this);
        });

        $(document).on("click", ".article-wrapper .pager .next", function () {
            onPagerNextClick(this);
        });

        $(document).on("click", ".article-wrapper .pager .index", function () {
            onPagerPageIndexItemClick(this);
        });

        /* Initit category-filter on "Beliebte" and show */
        $(".article-wrapper .category-wrapper .category[data-article-cat=All]").click();

        function onCategorySelection(categoryItem) {
            let $catItem = $(categoryItem);
            let $articleWrapper = $catItem.closest(".article-wrapper");
            let $articleBoxWrapper = $articleWrapper.find(".article-box-wrapper").first();

            $articleWrapper.find(".category-wrapper").find(".category").removeClass("active");
            $catItem.addClass("active");

            let selectedCat = $catItem.attr("data-article-cat");
            if (selectedCat == "All") {
                $articleBoxWrapper.children(".article-box").removeClass("hidden-by-filter");
            }
            else if (selectedCat == "most-popular") {
                $articleBoxWrapper.children(".article-box").each(function () {
                    let $box = $(this);
                    if ($box.is("[data-most-popular]")) {
                        $(this).removeClass("hidden-by-filter");
                    }
                    else {
                        $(this).addClass("hidden-by-filter");
                    }
                });
            }
            else {
                $articleBoxWrapper.children(".article-box").each(function () {
                    let $box = $(this);
                    let boxCat = $box.attr("data-article-cat");
                    //if (boxCat == selectedCat) {
                    if (boxCat.indexOf(`${selectedCat},`) >= 0) {
                        $(this).removeClass("hidden-by-filter");
                    }
                    else {
                        $(this).addClass("hidden-by-filter");
                    }
                });
            }

            showPage($articleWrapper, 0);
        }

        function onPagerPrevClick(prevItem) {
            let $pagerItem = $(prevItem);
            let $articleWrapper = $pagerItem.closest(".article-wrapper");
            let currentPageIndex = parseInt($articleWrapper.attr("data-page"));
            showPage($articleWrapper, currentPageIndex - 1);

            const elem = $articleWrapper[0];

            //$articleWrapper.scrollToViewport();
            let elementIsVisible = isInViewport(elem);
            if(elementIsVisible !== true) {
                scrollToElement(elem);
            }
        }

        function onPagerNextClick(nextItem) {
            let $pagerItem = $(nextItem);
            let $articleWrapper = $pagerItem.closest(".article-wrapper");
            let currentPageIndex = parseInt($articleWrapper.attr("data-page"));
            showPage($articleWrapper, currentPageIndex + 1);

            const elem = $articleWrapper[0];

            //$articleWrapper.scrollToViewport();
            let elementIsVisible = isInViewport(elem);
            if(elementIsVisible !== true) {
                scrollToElement(elem);
            }
        }

        function onPagerPageIndexItemClick(pagerItem) {
            let $pagerItem = $(pagerItem);
            let $articleWrapper = $pagerItem.closest(".article-wrapper");
            let newPageIndex = parseInt($pagerItem.attr("data-page-index"));
            showPage($articleWrapper, newPageIndex);

            const elem = $articleWrapper[0];

            let elementIsVisible = isInViewport(elem);
            if(elementIsVisible !== true) {
                scrollToElement(elem);
            }
        }

        function initPager($pager, currentPageIndex, maxPageIndex) {
            $pager.html("");

            let pageIndexBefore = currentPageIndex - 1;
            if (pageIndexBefore >= 0) {
                $pager.append("<span class=\"prev active\"><img src=\"/css/arrow_next.svg\" alt=\"Pfeil nach links\" />&nbsp;vorherige</span>");
                //$pager.append("<span class=\"prev active\"><i class=\"fas fa-chevron-left\"></i></span>");
                //$pager.append("<span class=\"prev active\"></span>");
            } else {
                $pager.append("<span class=\"prev\"><img src=\"/css/arrow_next.svg\" alt=\"Pfeil nach links\" />&nbsp;vorherige</span>");
                //$pager.append("<span class=\"prev\"><i class=\"fas fa-chevron-left\"></i></span>");
                //$pager.append("<span class=\"prev\"></span>");
            }
            let minLoopIndex = null;
            let maxLoopIndex = null;
            for (let i = 1; i <= 4; i++) {
                minLoopIndex = currentPageIndex - i;
                if (minLoopIndex < 0) {
                    minLoopIndex = 0;
                }
                maxLoopIndex = currentPageIndex + i;
                if (maxLoopIndex > maxPageIndex) {
                    maxLoopIndex = maxPageIndex;
                }
                //console.log(maxLoopIndex + " - " + minLoopIndex + " = " + (maxLoopIndex - minLoopIndex));
                if (maxLoopIndex - minLoopIndex >= 4) {
                    break;
                }
            }
            for (let pageIndex = minLoopIndex; pageIndex <= maxLoopIndex; pageIndex++) {
                addPageIndexItem($pager, pageIndex, currentPageIndex);
            }

            let pageIndexAfter = currentPageIndex + 1;
            if (pageIndexAfter <= maxPageIndex) {
                $pager.append("<span class=\"next active\">nächste&nbsp;<img src=\"/css/arrow_next.svg\" alt=\"Pfeil nach rechts\" /></span>");
                //$pager.append("<span class=\"next active\"><i class=\"fas fa-chevron-right\"></i></span>");
                //$pager.append("<span class=\"next active\"></span>");
            } else {
                $pager.append("<span class=\"next\">nächste&nbsp;<img src=\"/css/arrow_next.svg\" alt=\"Pfeil nach rechts\" /></span>");
                //$pager.append("<span class=\"next\"><i class=\"fas fa-chevron-right\"></i></span>");
                //$pager.append("<span class=\"next\"></span>");
            }
        }

        function addPageIndexItem($pager, pageIndex, currentPageIndex) {
            let pageNumber = pageIndex + 1;
            if (pageIndex == currentPageIndex) {
                $pager.append("<span class=\"current\">" + pageNumber + "</span>");
            }
            else {
                $pager.append("<span class=\"index active\" data-page-index=\"" + pageIndex + "\">" + pageNumber + "</span>");

            }
        }

        function showPage($articleWrapper, newPageIndex) {
            const PAGE_SIZE = 6;

            if (newPageIndex < 0) {
                return;
            }

            let itemStartIndex = newPageIndex * PAGE_SIZE;
            let allItems = $articleWrapper.find(".article-box:not(.hidden-by-filter)");
            let itemsToShow = [];

            if (itemStartIndex < allItems.length) {
                allItems.each(function (index) {
                    let $item = $(this);
                    if (!$item.hasClass(".hidden-by-filter")) {
                        if (itemsToShow.length < PAGE_SIZE && index >= itemStartIndex) {
                            $item.removeClass("hidden-by-pager");
                            itemsToShow.push($item);
                        } else {
                            $item.addClass("hidden-by-pager");
                        }
                    }
                });

                $articleWrapper.attr("data-page", newPageIndex);

                let $pager = $articleWrapper.find(".pager").first();
                let maxPageIndex = Math.ceil(allItems.length / PAGE_SIZE) - 1;
                initPager($pager, newPageIndex, maxPageIndex);
            }
        }



        function isInViewport(elem) {
            var distance = elem.getBoundingClientRect();
            return (
                distance.top >= 0 &&
                distance.left >= 0 &&
                distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                distance.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        function scrollToElement(elem) {
            $('html, body').animate({
                scrollTop: $(elem).offset().top
            }, 500);
        }
    };
}